<template>
  <div class="about" >
    <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>

  <div>
  <b-tabs content-class="mt-3" align="center">
    <b-tab title="My Profile" active>
      <div>
        <!-- <h5 ><v-icon>mdi-face</v-icon> &nbsp;Profile</h5> -->
        <profile></profile>
      </div>
    </b-tab>
    <b-tab title="My Orders">
      <div>
         <!-- <h5 ><v-icon>mdi-truck</v-icon> &nbsp;Order Details</h5> -->
      <order></order>
      </div>
      </b-tab>
    
  </b-tabs>
</div>
   
   
    
    
  </div>
  
</template>
<script>
import Vue from 'vue'
 import axios from 'axios';
 import Loading from 'vue-loading-overlay';
    // Import stylesheet
 import order from '@/components/orderdetails'
 import profile from '@/components/ProfileAccount'
 import Router from '../router';
 import 'vue-loading-overlay/dist/vue-loading.css';

// @ is an alias to /src

export default {
  components: {
            Loading,order,profile
        },
   
  data () {
    return {
      isLoading: false,
      fullPage: true,
      page:{
          name : 'My Account',
          intro : 'Welcome to'

      },
      snackbar: {
                show: false,
                message: null,
                color: null
       },
      title:'',
    
    }
  },
  mounted(){
    this.$parent.$children[0].$parent.ttlval = this.page.name
    console.log(this.$parent.$children[0].$parent.ttlval)
  }
}
</script>